import { Directive, ElementRef, Input, OnChanges, Renderer2, SimpleChanges } from "@angular/core";

@Directive({
  standalone: false,
  selector: "[fxFlexAlign]"
})
export class FxFlexAlignDirective implements OnChanges {
  @Input() fxFlexAlign?: string;

  constructor(
    private readonly host: ElementRef<HTMLElement>,
    private readonly renderer: Renderer2
  ) {}

  ngOnChanges(_: SimpleChanges): void {
    const value = (this.fxFlexAlign || "").trim().toLowerCase();
    this.renderer.setStyle(this.host.nativeElement, "align-self", this.mapAlign(value));
  }

  private mapAlign(value: string): string {
    switch (value) {
      case "center":
        return "center";
      case "end":
        return "flex-end";
      case "stretch":
        return "stretch";
      case "baseline":
        return "baseline";
      default:
        return "flex-start";
    }
  }
}
